import { render, staticRenderFns } from "./SurveyPageFooter.vue?vue&type=template&id=82c5dd2e"
import script from "./SurveyPageFooter.vue?vue&type=script&lang=ts"
export * from "./SurveyPageFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports